import React from 'react';
import { DatePicker, Button, Modal } from 'antd';
import { injectIntl } from 'react-intl';

class DateRangeModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateRange: [],
      dateStringRange: [],
    };
  }

  // when select the first date on RangePicker, show the date on panel
  onCalendarChange = date => {
    this.setState({
      dateRange: [...date],
    });
  }

  // Cancel the model and clear the dateRange state as Range picker can only capture the change status
  handleModelCancel = () => {
    this.props.handleCancel();
  }
  // Get the date time when date is changed
  handleDatePickerChange = (date, dateString) => {
    this.setState({
      dateRange: [...date],
      dateStringRange: [...dateString],
    });
  }
  // Submit the date range picker and cancel the model
  handleSubmit = async () => {
    await this.props.setPeriod(this.state.dateStringRange[0], this.state.dateStringRange[1], false);
    this.props.handleMultipleSelect();
    this.handleModelCancel();
  }

  render() {
    const { RangePicker } = DatePicker;
    const { visible, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <Modal
        title={formatMessage({ id: 'page.task.CUSTOMIZE' })}
        visible={visible}
        style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
        maskClosable={false} // click elsewhere will not close the modal
        onCancel={this.handleModelCancel}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button icon="save" key="save" size="small" type="default" onClick={this.handleSubmit}>
              {formatMessage({ id: 'page.task.confirm' })}
            </Button>
            <Button icon="close" key="cancel" size="small" type="danger" onClick={this.handleModelCancel}>
              {formatMessage({ id: 'page.task.cancel' })}
            </Button>
          </div>
                ]}
      >
        <RangePicker
          onChange={this.handleDatePickerChange}
          value={this.state.dateRange ? this.state.dateRange : null}
          onCalendarChange={this.onCalendarChange}
        />
      </Modal>
    );
  }
}

export default (injectIntl(DateRangeModel));



// WEBPACK FOOTER //
// ./src/views/Task/component/DateRangeModel.jsx